import { Fab } from "@mui/material";
import React from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { yellow } from "@mui/material/colors";

const DownArrowScroll = ({ scrollRef }) => {
  return (
    <div>
      <Fab
        onClick={() => scrollRef.current.scrollIntoView({ behavior: "smooth" })}
        style={{
          bottom: "80px",
          left: "48%",
          background: "transparent",
          boxShadow: "none",
          zIndex: 1,
        }}
      >
        <KeyboardArrowDownIcon
          style={{ fontSize: "40px" }}
          sx={{ color: yellow[50] }}
        ></KeyboardArrowDownIcon>
      </Fab>
    </div>
  );
};

export default DownArrowScroll;
